import React,{useRef,useEffect} from "react";
import ResponsiveReportsTable from "./Responsive/Reports-Table";
import AssessmentTable from "./Assessment-Table/Assessment-Table";
import CompletedReportsTable from "./Assessment-Table/Completed-reports-table";
import ResponsiveCompletedReportsTable from "./Responsive/Completed-Reports-Table";
import useOrientationChange from "../../../Utils/useOrientationChange";

const calcWidth = window.innerWidth;
const MyReports = (props) => {
 

  useOrientationChange()




  return (
    <div className="my-reports-table">
      {props.overlayIsVisible && <div className="overlay"></div>}
      <div>
        {props.assessmentUserId == props.assessmentFilteredId ? (
          calcWidth <= 767 ? (
            <ResponsiveCompletedReportsTable
              isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
              handleAssessmentPopOver={props.handleAssessmentPopOver}
              handleClosePopOver={props.handleClosePopOver}
              completedReports={props.completedReports}
              collapseID={props.collapseID}
              toggleCollapse={props.toggleCollapse}
              handleYearSelect = {props.handleYearSelect}
              isLoading={props.isLoading} 
            />
          ) : (
            <CompletedReportsTable
              isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
              handleAssessmentPopOver={props.handleAssessmentPopOver}
              handleClosePopOver={props.handleClosePopOver}
              completedReports={props.completedReports}
              handleYearSelect = {props.handleYearSelect}
              isLoading={props.isLoading} 
            />
          )
        ) : calcWidth <= 767 ? (
          <ResponsiveReportsTable
            isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
            handleAssessmentPopOver={props.handleAssessmentPopOver}
            handleClosePopOver={props.handleClosePopOver}
            myReports={props.myReports}
            collapseID={props.collapseID}
            toggleCollapse={props.toggleCollapse}
            handleYearSelect = {props.handleYearSelect}
            isLoading={props.isLoading} 
          />
        ) : (
          <AssessmentTable
            isPopOverOpenAssessmentId={props.isPopOverOpenAssessmentId}
            handleAssessmentPopOver={props.handleAssessmentPopOver}
            handleClosePopOver={props.handleClosePopOver}
            myReports={props.myReports}
            handleYearSelect = {props.handleYearSelect}
            isLoading={props.isLoading} 
          />
        )}
      </div>
    </div>
  );
};

export default MyReports;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/My-Reports/My-Reports.jsx